// Formatting + parsing for the Materials (cost catalog) card.
export const PAGE = 50;
export const RECENTS_KEY = 'strata.searchPicker.materials.recents';

export const byName = (a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' });

export function unitMoney(n) {
  if (n == null) return null;
  const v = Number(n);
  const digits = Math.abs(v * 100 - Math.round(v * 100)) > 1e-6 ? 4 : 2;
  return `$${v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: digits })}`;
}

// '' → null (no cost); '$1,234.50' → 1234.5; anything else → { error }.
export function parseCost(raw) {
  const s = String(raw ?? '').replace(/[\s$,]/g, '');
  if (!s) return { value: null };
  const v = Number(s);
  if (!Number.isFinite(v)) return { error: 'Enter a number, e.g. 4.25.' };
  if (v < 0 || v > 1000000) return { error: 'Cost must be between $0 and $1,000,000.' };
  return { value: Math.round(v * 10000) / 10000 };
}

export const detail = (e, fallback) => (typeof e?.response?.data?.detail === 'string' ? e.response.data.detail : fallback);
